import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { BaseSiteService, LanguageService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CustomInfluenzaService } from "src/app/custom-influenza/custom-influenza.service";
import { createReservationEng, createReservationFr, siteLanguagesEng, viewReservationEng, viewReservationFr } from "../../account-overview.constants";


@Component({
    selector: 'app-flu-content',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './flu-content.component.html',
    styleUrls: ['./flu-content.component.scss'],
    standalone: false
})
export class FluContentComponent implements OnInit, OnDestroy {
  userData: any = [];
  activeSeasons: any;
  endDate: any;
  orderHistory: any = [];
  reservationId: any;
  compNameAdBanner6 = 'SanofiAccountOverviewBannerComponent6';
  fluResevartion: boolean;
  createBtnText = createReservationEng;
  viewBtnText = viewReservationEng;
  activeSeasonsSubscriber: Subscription;
  orderHistorySubscriber: Subscription;
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    arrows: true,
  };
  userAccsubs: Subscription;
  displayActiveSeasons = true;
  seasonsList: any = [];
  slickInit(e): void { }
  breakpoint(e): void { }
  afterChange(e): void { }
  beforeChange(e): void { }
  constructor(
    private readonly user: UserAccountFacade,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly langService: LanguageService,
    private readonly baseSiteService: BaseSiteService
  ) { }
  baseSiteId: string;
  ngOnInit(): void {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.langService.getActive().subscribe((langResult) => {
      if (langResult) {
        if (langResult === siteLanguagesEng) {
          this.createBtnText = createReservationEng;
          this.viewBtnText = viewReservationEng;
        } else {
          this.createBtnText = createReservationFr;
          this.viewBtnText = viewReservationFr;
        }
        this.cdr.detectChanges();
      }
    });
    this.checkFluReservations();
  }
  checkFluReservations() {
    this.userAccsubs = this.user.get().subscribe((res) => {
      if (res) {
        this.userData = res;
        this.influenzaService.getActiveSeasonsForFluRes(this.userData.userName);
        this.activeSeasonsSubscriber = this.influenzaService.activeSeaons.subscribe((data) => {
          if (data) {
            this.seasonsList = data.categoryData;
            this.seasonsList?.forEach((season, index) => {
              this.influenzaService.getUserSeasonWiseOrders(this.userData.userName, season.code);
              this.influenzaService.seasonOrderHistory.subscribe(orderList => {
                if (Object.keys(orderList).length > 0) {
                  if (orderList.code === season.code) {
                    season.ordersList = orderList;
                    let data = season?.ordersList?.orders?.find((item) => item.orderStatus === "Confirmed");
                    season.fluOrderNumber = data ? data.fluOrderNumber : '';
                    season.fluResevartion = (season.activeSeason && season.ordersList?.orders?.length > 0 && season.fluOrderNumber !== '') ? true : false;
                  }
                }
                this.cdr.detectChanges();
              })
            })
          }
        })
      }
    })
  }
  checkInfReservations() {
    this.userAccsubs = this.user.get().subscribe((res) => {
      if (res) {
        this.userData = res;
        this.influenzaService.getActiveSeasonsFromDb(this.userData.userName);
        this.activeSeasonsSubscriber =
          this.influenzaService.activeSeaons.subscribe((data) => {
            if (!!data) {
              this.activeSeasons = data.categoryData[0]?.code;
              this.endDate = data.categoryData[0]?.endDate;
              this.activeSeasonsSubscriber?.unsubscribe();
              this.influenzaService.getUserOrderHistory(
                this.userData.userName,
                this.activeSeasons
              );
            }
            if (!data.categoryData?.[0]) {
              this.displayActiveSeasons = false;
            }
          });

        this.orderHistorySubscriber =
          this.influenzaService.ordersHistory.subscribe((data) => {
            this.orderHistory = data?.orders;
            if (this.orderHistory) {
              this.reservationId = this.orderHistory?.[0]?.guid;
            }
            if (this.orderHistory?.length > 0) {
              this.fluResevartion = true;
            }
            this.orderHistorySubscriber?.unsubscribe();
            this.cdr.detectChanges();
          });
      }
    });
  }
  onManageSetting() {
    localStorage.setItem('tabSelected', 'Influenza Settings');
    this.router.goByUrl('/my-account/profile');
  }
  onInfRedirect() {
    this.router.goByUrl('/influenza/dashboard');
  }
  onInfClick() {
    if (this.fluResevartion) {
      this.influenzaService.getDetailedReservation(
        this.userData.userName,
        this.reservationId,
        true
      );
    } else {
      this.router.goByUrl('/influenza/dashboard');
    }
  }
  navigatetoDb() {
    this.router.goByUrl('/influenza/dashboard');
  }
  ngOnDestroy() {
    this.activeSeasonsSubscriber?.unsubscribe();
    this.orderHistorySubscriber?.unsubscribe();
    this.userAccsubs?.unsubscribe();
  }
}
